import arrowIcon from "./arrow1.png";
import arrowIcon2 from "./arrow2.png";

const customIcons = {
  arrowIcon,
  arrowIcon2,
};

export default customIcons;
